































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import {
  required,
  maxLength,
  totalLength,
  greaterOrEquals,
  lessOrEquals,
} from '@/utils/ValidationUtil'
import Magistrado from '@/model/Magistrado'
import Expediente from '@/model/Expediente'
import { expedienteApi } from '@/api'

@Component({
  components: {},
})
export default class CargaMagistrado extends Vue {
  $refs: {
    form: Vue & { validate(): boolean; resetValidation(): void; reset(): void }
  }

  @Prop({ default: false, type: Boolean })
  private disabled: boolean

  @Prop()
  private value: Expediente | undefined

  @Prop()
  private nombreEntidad: string
  private rules = {
    required,
    maxLength500: maxLength(500),
    length4: totalLength(4),
    greaterOrEquals2017: greaterOrEquals((): number => 2017),
    maxLength6: maxLength(6),
    lessOrEquals: lessOrEquals(this.calcularMax.bind(this)),
  }

  private magistrado: Magistrado | any = {}
  private expediente: Expediente | undefined = this.newInstance()
  private loading = false
  private valid = true
  private lazy = true
  private errorMessages: string[] = []
  newInstance() {
    return {
      id: undefined as unknown as number,
      caratula: '',
      resolucion: {
        numero: undefined as unknown as number,
        anio: undefined as unknown as number,
      },
    }
  }

  validate() {
    return this.$refs.form.validate()
  }
  calcularMax(): number | undefined {
    return new Date().getUTCFullYear()
  }
  reset() {
    return this.$refs.form.reset()
  }

  showMessage() {
    return this.errorMessages.length > 0
      ? `${this.errorMessages}`
      : this.expediente?.caratula
      ? `Carátula: "${this.expediente?.caratula}"`
      : ''
  }
  resetValidation() {
    return this.$refs.form.resetValidation()
  }
  @Watch('value')
  updateValue() {
    this.expediente = JSON.parse(JSON.stringify(this.value))
  }

  async searchExpediente() {
    this.clearErrors()
    if (this.validate()) {
      try {
        this.loading = true
        let expediente: Expediente = await expedienteApi.findByNumeroAnio(
          this.expediente?.resolucion.numero as number,
          this.expediente?.resolucion.anio as number
        )
        this.expediente = expediente
        this.$emit('input', this.expediente)
      } catch (error) {
        this.errorMessages = ['No se encontró el expediente']
      } finally {
        this.loading = false
      }
    }
  }
  private clearErrors() {
    this.errorMessages = []
    this.resetValidation()
  }
  private clearComponent() {
    this.expediente = this.newInstance()
    this.$emit('input', this.expediente)
    this.errorMessages = []
    this.resetValidation()
  }
  beforeDestroy() {
    this.clearComponent()
  }
}
